import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { SectionWrapper } from '../../../../../styledComponents/Form/Form';
import { SmallModal } from '../../../../../styledComponents/ModalCommon/ModalCommon';
import ModalFormPage from '../../../../../styledComponents/ModalFormPage/ModalFormPage';
import FormCheckboxGroup from '../../../../../styledComponents/UI/Form/FormCheckboxGroup/FormCheckboxGroup';
import {
  aaMembershipOptionsList,
  EDIT_AA_MEMBERSHIP_OPTIONS_MODAL,
} from './editAAMembershipOptionsModal.const';
import { useEditAAMembershipOptionsModal } from './editAAMembershipOptionsModal.hooks';

interface IEditAAMembershipOptionsModalProps {
  onModalCancel?: () => void;
  onMembershipOptionsUpdated?: () => void;
  id?: string;
}

const EditAAMembershipOptionsModal = ({
  onModalCancel,
  onMembershipOptionsUpdated,
  id,
}: IEditAAMembershipOptionsModalProps) => {
  const { t } = useTranslation();
  const {
    updateMembershipOptionsHandler,
    membershipOptions,
    isProcessing,
    onCloseHandler,
  } = useEditAAMembershipOptionsModal({ id });

  return (
    <SmallModal
      disabled={isProcessing}
      name={EDIT_AA_MEMBERSHIP_OPTIONS_MODAL + id}
      onModalClose={onModalCancel}
    >
      <Form
        keepDirtyOnReinitialize
        onSubmit={updateMembershipOptionsHandler}
        initialValues={membershipOptions}
      >
        {({ ...renderProps }) => (
          <ModalFormPage
            mode="small"
            handleSubmit={renderProps.handleSubmit}
            isProcessing={isProcessing}
            onCancel={onCloseHandler}
            title={t('headers.edit-options')}
          >
            <SectionWrapper>
              <FormCheckboxGroup
                layout="column"
                options={aaMembershipOptionsList}
              />
            </SectionWrapper>
          </ModalFormPage>
        )}
      </Form>
    </SmallModal>
  );
};

export default EditAAMembershipOptionsModal;
